<div class="form-page">
    <div class="steps-grafic">
        <app-registry-steps-grafic></app-registry-steps-grafic>
    </div>
    <div class="text-container-right">
        <app-organisation-edit-settings class="right-container-width"></app-organisation-edit-settings>
    </div>
</div>